<template>
  <div class="o-wrapper">
    <div class="c-header">
        <slot name="header"></slot>
    </div>
    <div class="o-main-grid o-main-grid--dashboard">
      <div class="container">
        <slot name="content"></slot>
        </div>
    </div>
    <div class="">
        <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageLayout',
}
</script>
